"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitationRequestToJSON = exports.AcceptInvitationRequestFromJSONTyped = exports.AcceptInvitationRequestFromJSON = exports.instanceOfAcceptInvitationRequest = void 0;
/**
 * Check if a given object implements the AcceptInvitationRequest interface.
 */
function instanceOfAcceptInvitationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "emailAddress" in value;
    isInstance = isInstance && "hasMarketingOptIn" in value;
    isInstance = isInstance && "invitationId" in value;
    return isInstance;
}
exports.instanceOfAcceptInvitationRequest = instanceOfAcceptInvitationRequest;
function AcceptInvitationRequestFromJSON(json) {
    return AcceptInvitationRequestFromJSONTyped(json, false);
}
exports.AcceptInvitationRequestFromJSON = AcceptInvitationRequestFromJSON;
function AcceptInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'emailAddress': json['email_address'],
        'hasMarketingOptIn': json['has_marketing_opt_in'],
        'invitationId': json['invitation_id'],
    };
}
exports.AcceptInvitationRequestFromJSONTyped = AcceptInvitationRequestFromJSONTyped;
function AcceptInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'email_address': value.emailAddress,
        'has_marketing_opt_in': value.hasMarketingOptIn,
        'invitation_id': value.invitationId,
    };
}
exports.AcceptInvitationRequestToJSON = AcceptInvitationRequestToJSON;
